<motif-modal-title variant="alt">
    <img src="/assets/images/red.svg" />
  <h3 class="mTitle">{{ data.itemHeader }}</h3>
  <button motifIconButton aria-label="Close modal" [motif-modal-close]="true">
    <motif-icon
      [src]="'/assets/icons/navigation/ic_close_24px.svg'"
    ></motif-icon>
  </button>
</motif-modal-title>
<motif-modal-content>
  <div class="container">
    <div class="actionCard" *ngFor="let item of data.items">
      <label
        class="tagLabel"
        [ngClass]="{
          green: item.priority === 'LOW',
          red: item.priority === 'HIGH',
          yellow: item.priority === 'MEDIUM'
        }"
      >
        {{ item.priority }}</label
      >
      <h3>{{ item.name }}</h3>
      <div class="cardDetails">
        <div class="wrapper">
          <motif-avatar
            size="medium"
            [userName]="userDetails.displayName"
            [src]="userDetails.base64ProfileImage"
          ></motif-avatar>
          <div class="actionLabel">
            <label>Assigned To</label>
            <span>{{ item.assignedUserName }}</span>
          </div>
        </div>
        <div class="actionLabel">
          <label>Due Date</label>
          <span>{{ item.dueDate  | date : "dd/MM/yyyy"  }}</span>
        </div>
      </div>
    </div>
  </div>
</motif-modal-content>
